import React, { useState, CSSProperties } from 'react';
import { SxProps, Box, Collapse } from '@mui/material';

interface AccordionProps {
  title: JSX.Element,
  children: React.ReactNode;
  defaultOpen?: boolean;
  headerStyleOverrides?: CSSProperties;
  arrowStyleOverrides?: CSSProperties;
}

export const Accordion = ({
  title,
  children,
  defaultOpen = false,
  headerStyleOverrides,
  arrowStyleOverrides,
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const headerStyle: SxProps = {
    cursor: 'pointer',
    padding: '10px 0',
    color: '#3a86ff',
    fontWeight: 'bold',
    // display: "flex",
    // alignItems: "center",
    ...headerStyleOverrides,
  };

  const arrowStyle: SxProps = {
    border: 'solid',
    borderWidth: '0 4px 4px 0',
    display: 'inline-block',
    padding: '3px',
    margin: '0 10px',
    transform: isOpen ? 'rotate(45deg)' : 'rotate(-45deg)',
    transition: 'transform 0.05s ease',
    ...arrowStyleOverrides,
  };

  return (
    <>
      <Box
        sx={headerStyle}
        onClick={() => setIsOpen((o) => !o)}
      >
        <Box sx={arrowStyle} />
        <Box component='span'>{title}</Box>
      </Box>
      <Collapse in={isOpen} timeout='auto' unmountOnExit={false}>
        <Box>{children}</Box>
      </Collapse>
    </>
  );
};

export default Accordion;
